{
  "roleId": "role-210000-mfrs",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-210000",
  "label": "[210000] Statement of financial position, by current/non-current method (MFRS)",
  "taxonomy": "FS-MFRS",
  "controls": [
    {
      "qname": "ssmt:DisclosureOnStatementOfProfitOrLossByFunctionAbstract",
      "label": "Statement of financial position",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:AssetsAbstract",
      "label": "Assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentAssetsAbstract",
      "label": "Non-current assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PropertyPlantAndEquipment",
      "label": "Property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:PropertyPlantAndEquipment"
        }
      }
    },
    {
      "qname": "ifrs-full:InvestmentProperty",
      "label": "Investment property",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:InvestmentProperty"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentBiologicalAssets",
      "label": "Biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:RightofuseAssets",
      "label": "Right-of-use asset",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentServiceConcessionAssets",
      "label": "Service concession assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:IntangibleAssetsAndGoodwill",
      "label": "Intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:IntangibleAssetsAndGoodwill"
        }
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInSubsidiaries",
      "label": "Investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:InvestmentsInSubsidiaries"
        }
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInAssociates",
      "label": "Investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:InvestmentsInAssociates"
        }
      }
    },
    {
      "qname": "ifrs-full:InvestmentsInJointVentures",
      "label": "Investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:InvestmentsInJointVentures"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentInvestmentsOtherThanInvestmentsAccountedForUsingEquityMethod",
      "label": "Other investments",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:NoncurrentReceivables",
      "label": "Trade and other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentReceivables"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentContractAssets",
      "label": "Contract assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:DeferredTaxAssets",
      "label": "Deferred tax assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialAssets",
      "label": "Derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentDerivativeFinancialAssets"
        }
      }
    },
    {
      "qname": "ifrs-full:OtherNoncurrentAssets",
      "label": "Other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:OtherNoncurrentAssets"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentAssets",
      "required": true,
      "label": "Total non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:CurrentAssetsAbstract",
      "label": "Current assets",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InventoriesTotal",
      "label": "Inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:InventoriesTotal"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentBiologicalAssets",
      "label": "Biological assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentInvestments",
      "label": "Other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentTaxAssetsCurrent",
      "label": "Current tax assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentReceivables",
      "label": "Trade and other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:TradeAndOtherCurrentReceivables"
        }
      }
    },
    {
      "qname": "ifrs-full:CurrentContractAssets",
      "label": "Contract assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialAssets",
      "label": "Derivative financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:CurrentDerivativeFinancialAssets"
        }
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "label": "Cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt:CashAndBankBalances"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ssmt:CashAndBankBalances"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentAssets",
      "label": "Other current assets",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentAssetsOtherThanAssetsOrDisposalGroupsClassifiedAsHeldForSaleOrAsHeldForDistributionToOwners",
      "label": "Total current assets other than assets held for sale",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentAssetsOrDisposalGroupsClassifiedAsHeldForSaleOrAsHeldForDistributionToOwners",
      "label": "Non-current assets or disposal groups classified as held for sale or as held for distribution to owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentAssets",
      "required": true,
      "label": "Total current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:Assets",
      "required": true,
      "label": "Total assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ifrs-full:EquityAndLiabilities"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:EquityAndLiabilitiesAbstract",
      "label": "Equity and Liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:EquityAbstract",
      "label": "Equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IssuedCapital",
      "label": "Issued capital",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:IssuedCapital"
        }
      }
    },
    {
      "qname": "ifrs-full:RetainedEarnings",
      "label": "Retained earnings",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:TreasuryShares",
      "label": "(-) Treasury shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:OtherReserves",
      "label": "Reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:OtherReserves"
        }
      }
    },
    {
      "qname": "ifrs-full:EquityAttributableToOwnersOfParent",
      "required": true,
      "label": "Total equity attributable to owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherComponentsOfEquity",
      "label": "Equity - other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ssmt-mfrs:OtherComponentsOfEquity"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncontrollingInterests",
      "label": "Non-controlling interests",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:Equity",
      "required": true,
      "label": "Total equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:LiabilitiesAbstract",
      "label": "Liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:NoncurrentLiabilitiesAbstract",
      "label": "Non-current liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentServiceConcessionLiabilities",
      "label": "Service concession liabilities",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:LongtermBorrowings",
      "label": "Borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:LongtermBorrowings"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:NoncurrentFinanceLeaseLiabilities",
      "label": "Lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:NoncurrentProvisionsForEmployeeBenefits",
      "label": "Employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentProvisionsForEmployeeBenefits"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentProvisions",
      "label": "Provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentProvisions"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentPayables",
      "label": "Trade and other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentPayables"
        }
      }
    },
    {
      "qname": "ifrs-full:NoncurrentContractLiabilities",
      "label": "Contract liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:DeferredTaxLiabilities",
      "label": "Deferred tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:NoncurrentDerivativeFinancialLiabilities",
      "label": "Derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:NoncurrentDerivativeFinancialLiabilities"
        }
      }
    },
    {
      "qname": "ifrs-full:OtherNoncurrentLiabilities",
      "label": "Other non-current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:NoncurrentLiabilities",
      "label": "Total non-current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:CurrentLiabilitiesAbstract",
      "label": "Current liabilities",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CurrentPortionOfLongtermBorrowings",
      "label": "Borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:ShorttermBorrowings"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:CurrentFinanceLeaseLiabilities",
      "label": "Lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentProvisionsForEmployeeBenefits",
      "label": "Employee benefit liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:CurrentProvisionsForEmployeeBenefits"
        }
      }
    },
    {
      "qname": "ifrs-full:CurrentProvisions",
      "label": "Provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:CurrentProvisions"
        }
      }
    },
    {
      "qname": "ifrs-full:CurrentTaxLiabilitiesCurrent",
      "label": "Current tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:TradeAndOtherCurrentPayables",
      "label": "Trade and other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:TradeAndOtherCurrentPayables"
        }
      }
    },
    {
      "qname": "ifrs-full:CurrentContractLiabilities",
      "label": "Contract liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentDerivativeFinancialLiabilities",
      "label": "Derivative financial liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": false,
        "linkTo": {
          "role": "210100",
          "qname": "ifrs-full:CurrentDerivativeFinancialLiabilities"
        }
      }
    },
    {
      "qname": "ifrs-full:OtherCurrentLiabilities",
      "label": "Other current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentLiabilitiesOtherThanLiabilitiesIncludedInDisposalGroupsClassifiedAsHeldForSale",
      "label": "Total current liabilities other than liabilities held for sale",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:LiabilitiesIncludedInDisposalGroupsClassifiedAsHeldForSale",
      "label": "Liabilities included in disposal groups classified as held for sale",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:CurrentLiabilities",
      "required": true,
      "label": "Total current liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:Liabilities",
      "required": true,
      "label": "Total liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:EquityAndLiabilities",
      "required": true,
      "label": "Total equity and liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfFinancialPosition",
            "field": "ifrs-full:Assets"
          }
        ]
      }
    }
  ]
}
